import React, { ChangeEvent, useCallback, useContext, useEffect, useState } from 'react'
import Footer from '../Home/components/Footer'
import SearchIcon from '@mui/icons-material/Search'
import { TenantsContext } from '../../context/tenants.context'
import Navbar from '../../components/Navbar'
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  ImageList,
  ImageListItem,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { DeleteOutline, Add } from '@mui/icons-material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { autocomplete } from '../../services/autocomplete'
import { axiosInstanceMain } from '../../utils/axiosGlobalUtils'
import { ContentSoloActivos } from './AbmLocalesPage'
import UploadImg from './uploadFotoLocal'
import ExpandImageDialog from '../Products/components/ExpandImage'
import SnackBarUtils from '../../utils/SnackBarUtils'
import ConfirmDialog from '../Products/components/ConfirmDialog'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const FotosLocales: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [autocompletado, setAutoCompletado] = useState<string[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [fotos, setFotos] = useState<any[]>(null)
  const [openAutocomplete, setOpenAutocomplete] = useState(false)
  const [showIcons, setShowIcons] = useState<boolean>(false)
  const [imgSelected, setImgSelected] = useState<string>(null)
  const [expandImg, setExpandImg] = useState<boolean>(false)
  const [openUploadFile, setOpenUploadFile] = useState<boolean>(false)
  const [soloActivos, setSoloActivos] = useState<boolean>(false)
  const [queryLocal, setQueryLocal] = useState<any>(null)
  const { tenant } = useContext(TenantsContext)
  const [confirmDialog, setConfirmDialog] = useState<any>({
    open: false,
    text: {
      title: '',
      body: '',
      leftButton: 'Cancelar',
      rightButton: 'Confirmar',
      colorButtonConfirm: 'primary'
    },
    action: async () => {}
  })

  const clearConfirmDialog = () => {
    setConfirmDialog((confirmDialog: any) => ({
      ...confirmDialog,
      open: false
    }))
  }

  const handleAutoCompletado = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target

    if (!value || value?.length < 3) return setQueryLocal(null)

    autocomplete(tenant, value, soloActivos)
      .then((result) => {
        setAutoCompletado(result.data.data)
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  const getGaleria = useCallback(() => {
    if (!queryLocal?.data) return
    setLoading(true)
    axiosInstanceMain
      .get(`/admin/${tenant.path}/locales/${queryLocal.data}/imagenes`)
      .then((result) => {
        setFotos(result.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => setLoading(false))
  }, [queryLocal?.data, tenant])

  const handleDelete = useCallback(
    (idFoto: number) => {
      setConfirmDialog({
        open: true,
        text: {
          title: '¿Deseás eliminar esta imagen?',
          body: ``,
          leftButton: 'Cancelar',
          rightButton: 'Confirmar',
          colorButtonConfirm: 'error'
        },
        action: async () => {
          try {
            setLoading(true)
            await axiosInstanceMain.delete(`/admin/${tenant.path}/locales/imagenes/${idFoto}`)
            SnackBarUtils.success('Imagen eliminada')
            setImgSelected(null)
            await getGaleria()
          } catch (e) {
            console.log(e)
          } finally {
            setLoading(false)
            clearConfirmDialog()
          }
        },
        close: () => clearConfirmDialog()
      })
    },
    [tenant, getGaleria]
  )

  const searchPremises = () => {
    setOpenAutocomplete(false)
    getGaleria()
  }

  const formatDate = (dateString: string) => {
    return dayjs.utc(dateString).tz('America/Argentina/Buenos_Aires').format('DD/MM/YYYY H:mm:ss')
  }

  return (
    <>
      <Navbar title="Fotos de local" searchBar={{ searchBar: true }} />
      <form
        style={{ width: '100%' }}
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '1rem',
            padding: '1rem',
            width: '100%'
          }}
        >
          <Autocomplete
            sx={{ flex: 1 }}
            open={openAutocomplete}
            onOpen={() => setOpenAutocomplete(true)}
            onClose={() => setOpenAutocomplete(false)}
            disableClearable
            options={autocompletado}
            filterOptions={(x) => x}
            isOptionEqualToValue={(option, value) => option.data === value.data}
            getOptionLabel={(option: any) => option.nombre}
            inputValue={queryLocal?.nombre}
            onChange={(e, value) => {
              if (value) {
                setQueryLocal(value)
              }
            }}
            onKeyPress={(e) => e.key === 'Enter' && searchPremises()}
            renderInput={(p) => (
              <TextField
                {...p}
                label="Busca por nombre o ID"
                variant="outlined"
                onChange={handleAutoCompletado}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                    searchPremises()
                  }
                }}
                sx={{
                  backgroundColor: 'white',
                  '& .MuiOutlinedInput-root': {
                    padding: '0.5rem',
                    '& fieldset': {
                      borderColor: '#868e96',
                      borderWidth: '1.5px'
                    }
                  }
                }}
              />
            )}
          />
          <ContentSoloActivos>
            <FormControlLabel
              sx={{ flex: 1, whiteSpace: 'nowrap' }}
              control={<Checkbox checked={soloActivos} onChange={(e) => setSoloActivos(e.target.checked)} />}
              label="Sólo activos"
            />
          </ContentSoloActivos>
          <button type="submit" onClick={searchPremises} className="btn btn-primary btn-lg">
            <SearchIcon />
          </button>
        </div>
      </form>
      {fotos?.length > 0 && (
        <div style={{ padding: '1rem', width: '100%' }}>
          <ImageList cols={isMobile ? 1 : 4} gap={12}>
            {fotos.map((foto, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    width: '100%',
                    height: 290,
                    aspectRatio: '1/1',
                    '&:hover .overlay': {
                      opacity: isMobile ? undefined : 1
                    }
                  }}
                  onClick={() => {
                    if (isMobile) {
                      setImgSelected(foto.url)
                      setShowIcons(!showIcons)
                    }
                  }}
                >
                  <img
                    src={foto.url}
                    alt={foto.titulo || `foto-${index}`}
                    loading="lazy"
                    style={{
                      borderRadius: '8px',
                      objectFit: 'cover',
                      width: '100%',
                      height: '100%'
                    }}
                  />
                  <Box
                    className="overlay"
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      bgcolor: 'rgba(0,0,0,0.5)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 2,
                      opacity: foto.url === imgSelected ? 1 : 0,
                      transition: 'opacity 0.3s ease'
                    }}
                  >
                    <IconButton
                      disabled={loading}
                      aria-label="expand"
                      size="medium"
                      onClick={() => {
                        if (!isMobile || showIcons) {
                          setImgSelected(foto.url)
                          setExpandImg(true)
                        }
                      }}
                      sx={{
                        color: 'white',
                        '&:hover': {
                          color: 'dodgerblue'
                        }
                      }}
                    >
                      <VisibilityIcon fontSize="inherit" />
                    </IconButton>
                    <IconButton
                      disabled={loading}
                      aria-label="delete"
                      size="medium"
                      onClick={() => {
                        if (!isMobile || showIcons) {
                          handleDelete(foto.idFotoLocal)
                        }
                      }}
                      sx={{
                        color: 'white',
                        '&:hover': {
                          color: 'red'
                        }
                      }}
                    >
                      <DeleteOutline fontSize="inherit" />
                    </IconButton>
                  </Box>
                </Box>
                <Box
                  sx={{
                    mt: 1,
                    width: '100%',
                    textAlign: 'center'
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '0.8rem', wordBreak: 'break-word' }}>
                    {foto.titulo || 'Sin título'}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                    {foto.fecha && formatDate(foto.fecha)}
                  </Typography>
                </Box>
              </Box>
            ))}
          </ImageList>
        </div>
      )}

      {fotos && (
        <Button
          disabled={loading}
          onClick={() => setOpenUploadFile(true)}
          sx={{ marginLeft: '1rem', marginBottom: '3rem' }}
          variant="outlined"
        >
          Upload <FileUploadIcon />
        </Button>
      )}
      <Footer />
      {queryLocal?.data && (
        <UploadImg
          open={openUploadFile}
          setOpen={setOpenUploadFile}
          codLocal={queryLocal.data}
          updateGaleria={getGaleria}
        />
      )}
      <ConfirmDialog {...confirmDialog} />
      <ExpandImageDialog
        open={expandImg}
        setExpandImage={setExpandImg}
        imageUrl={imgSelected}
        setImageUrl={setImgSelected}
      />
    </>
  )
}

export default FotosLocales
